import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  saveAboutClinic,
  upload1Image,
  upload2Image,
} from "../../../../redux/slices/mainDataSlice";
import { toast } from "react-toastify";
export default function AboutClinic() {
  const data = useSelector((state) => state.main.data?.mainData?.[0]);
  const [clinicPhoto1, setClinicPhoto1] = useState("");
  const [clinicPhoto2, setClinicPhoto2] = useState("");
  const [textEdit, setTextEdit] = useState(false);
  const [text, setText] = useState("");
  const dispatch = useDispatch();

  const handleFile1Change = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onloadstart = () => {
      // Display loader when upload starts
      toast.info("Uploading image...", { autoClose: false });
    };

    reader.onload = () => {
      setClinicPhoto1(reader.result);
      dispatch(upload1Image(file))
        .then(() => {
          // Hide loader and show success message when upload is successful
          toast.success("Image uploaded successfully");
        })
        .catch(() => {
          // Hide loader and show error message when upload fails
          toast.error("Failed to upload image");
        });
    };

    reader.onerror = (error) => {
      // Handle file reading error
      console.error("File reading error:", error);
      toast.error("Error reading file");
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };
  const handleFile2Change = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onloadstart = () => {
      // Display loader when upload starts
      toast.info("Uploading image...", { autoClose: false });
    };

    reader.onload = () => {
      setClinicPhoto2(reader.result);
      dispatch(upload2Image(file))
        .then(() => {
          // Hide loader and show success message when upload is successful
          toast.success("Image uploaded successfully");
        })
        .catch(() => {
          // Hide loader and show error message when upload fails
          toast.error("Failed to upload image");
        });
    };

    reader.onerror = (error) => {
      // Handle file reading error
      console.error("File reading error:", error);
      toast.error("Error reading file");
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };
  const handleSaveTextChange = (event) => {
    setTextEdit(false);
    dispatch(saveAboutClinic({ text }))
      .then(() => {
        // Hide loader and show success message when upload is successful
        toast.success("Text Edited successfully");
      })
      .catch(() => {});
  };
  return (
    <section className="about-clinic-home" id="clinic">
      <div
        className="head-title"
        data-aos="fade-left"
        data-aos-duration="1000"
        data-aos-offset="300"
      >
        <span>عن العيادة</span>
      </div>
      <div className="container">
        {" "}
        <div className="right">
          <div
            className="text"
            data-aos="fade-left"
            data-aos-duration="1000"
            data-aos-offset="400"
          >
            <textarea
              value={text ? text : data?.about_clinc}
              disabled={!textEdit}
              onChange={(e) => setText(e.target.value)}
            />
            {!textEdit ? (
              <div className="edit-icon" onClick={() => setTextEdit(!textEdit)}>
                <img src="/images/edit-text.png" alt="" />
              </div>
            ) : (
              <div className="save-icon" onClick={handleSaveTextChange}>
                <img src="/images/text.png" alt="" />
              </div>
            )}
          </div>

          <div className="bottom" data-aos="fade-in" data-aos-offset="200">
            <div className="one"></div>
            <div className="two"></div>
          </div>
        </div>
        <div className="left">
          <div className="effects">
            <div
              className="effect one"
              data-aos="fade-up-right"
              data-aos-duration="1000"
              data-aos-offset="300"
            ></div>
            <div
              className="effect two"
              data-aos="fade-up-left"
              data-aos-duration="1000"
              data-aos-offset="300"
            ></div>
            <div
              className="effect thee"
              data-aos="fade-up"
              data-aos-duration="1000"
              data-aos-offset="300"
            ></div>
          </div>
          <div className="images">
            <div className="image-container one">
              <div className="image">
                <img
                  src={
                    clinicPhoto1
                      ? `${clinicPhoto1}`
                      : `https://api.atharalfarasha.com/public/hakim/${data?.clinc_pic_1}`
                  }
                  alt=""
                />
              </div>
              <label htmlFor="add-icon1" className="add-icon">
                <lord-icon
                  src="https://cdn.lordicon.com/fowixcuo.json"
                  trigger="hover"
                  state="hover-upload-2"
                  className="img"
                  style={{ width: "50px", height: "50px" }}
                ></lord-icon>
                <input
                  type="file"
                  id="add-icon1"
                  style={{ display: "none" }}
                  onChange={handleFile1Change} // Corrected function call
                  accept="image/*"
                />
              </label>
            </div>
            <div className="image-container two">
              <div className="image">
                <img
                  src={
                    clinicPhoto2
                      ? `${clinicPhoto2}`
                      : `https://api.atharalfarasha.com/public/hakim/${data?.clinic_pic_2}`
                  }
                  alt=""
                />
              </div>
              <label htmlFor="add-icon2" className="add-icon">
                <lord-icon
                  src="https://cdn.lordicon.com/fowixcuo.json"
                  trigger="hover"
                  state="hover-upload-2"
                  className="img"
                  style={{ width: "50px", height: "50px" }}
                ></lord-icon>
                <input
                  type="file"
                  id="add-icon2"
                  style={{ display: "none" }}
                  onChange={handleFile2Change} // Corrected function call
                  accept="image/*"
                />
              </label>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
